module.exports = __webpack_public_path__ + "img/white.8631f620.webp";